<template>
  <div class="main-container">
    <OrderStep></OrderStep>
    <div class="address-wrap" v-if="type == 12 || shop.is_materials == 1">
      <div class="order-title">配送至</div>
      <div
        class="clearfix address-list"
        :style="
          addressExpand || addressList.length == 0 ? 'height:auto' : 'height:179px;overflow:hidden;'
        "
      >
        <el-card
          class="address"
          :class="{ current: address.id == address_id }"
          shadow="never"
          v-for="address in addressList"
          :key="address.id"
          @click.native="address_id = address.id"
        >
          <div
            class="title"
            :title="address.province_name + address.city_name + '（' + address.user_name + '收）'"
          >
            {{ address.province_name + address.city_name + '（' + address.user_name + '收）' }}
          </div>
          <div class="detail">
            {{
              address.province_name +
              ' ' +
              address.city_name +
              ' ' +
              address.district_name +
              ' ' +
              address.address
            }}
          </div>
          <img
            class="default"
            src="../../images/goods/address-default@2x.png"
            v-if="address.is_default == 1"
          />
          <img
            class="ok"
            src="../../images/goods/address-ok@2x.png"
            v-if="address.id == address_id"
          />
        </el-card>
      </div>
      <div
        class="clearfix address-op"
        :class="{
          'address-op-expand': addressExpand == 1 || addressList.length == 0,
        }"
      >
        <span class="tip">
          {{ shop.is_materials == 1 && type != 12 ? '此地址只用于邮寄实体教材，请准确填写' : '' }}
        </span>
        <span
          class="expand"
          v-if="!addressExpand && addressList.length > 4"
          @click="addressExpand = 1"
        >
          全部地址
        </span>
        <span
          class="collapse"
          v-if="addressExpand && addressList.length > 4"
          @click="addressExpand = 0"
        >
          收起
        </span>
        <span class="add" @click="addAddress">新增收货地址</span>
      </div>
    </div>
    <div class="shop-detail">
      <div class="order-title">商品明细</div>
      <table class="table-goods" :class="{ ['table-goods-' + type]: true }" cellspacing="0">
        <thead>
          <tr>
            <th class="name">商品名称</th>
            <th class="valid" v-if="type == 19">有效期</th>
            <th class="price price-unit" v-if="type == 12">单价</th>
            <th class="num" :class="{ ['num-' + type]: true }" v-if="type == 12 || type == 17">
              数量
            </th>
            <th
              class="price"
              :class="{
                ['price-' + type]: true,
                'price-discount': discountId,
              }"
            >
              商品金额
            </th>
            <template v-if="discountId || packageId">
              <th class="price price-lianbao" v-if="discountId">联报优惠</th>
              <th v-if="shop.use_coupon == 1" class="coupon">优惠券</th>
            </template>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in shop.items" :key="index">
            <td class="name">
              <div class="cover-wrap" v-if="item.cover_img && type != 17 && type != 22">
                <img class="cover" :src="item.cover_img" />
                <span>{{ item.title }}</span>
              </div>
              <template v-else>
                {{ item.title }}
              </template>
            </td>
            <td class="valid" v-if="type == 19">
              <template v-if="item.valid_type == 1">长期有效</template>
              <template v-else>
                {{ item.valid_time | tsFormat('yyyy/MM/dd') }}
              </template>
            </td>
            <td class="price price-unit" v-if="type == 12">
              <div class="price-wrap">
                <Currency></Currency>
                <span>{{ item.price | price }}</span>
              </div>
            </td>
            <td class="num" v-if="type == 12">
              <span>{{ num }}</span>
            </td>
            <td class="num num-17" v-else-if="type == 17">
              <span>{{ item.product_number }}</span>
            </td>
            <td
              class="price"
              :class="{
                'is-discount-price': discountId,
                'price-discount': discountId,
                ['price-' + type]: true,
              }"
            >
              <div class="price-wrap">
                <Currency></Currency>
                <span v-if="type == 17">{{ item.paid_price | price }}</span>
                <span v-else>
                  {{ (item.price * (item.product_number || 1)) | price }}
                </span>
              </div>
            </td>
            <template v-if="discountId || packageId">
              <td class="price price-lianbao" v-if="discountId">
                <div class="price-wrap">
                  -
                  <Currency></Currency>
                  <span>{{ item.discount_price | price }}</span>
                </div>
              </td>
              <td class="coupon" v-if="shop.use_coupon == 1">
                <el-select
                  v-model="item.checked_coupon_id"
                  :placeholder="
                    mixedCoupon[item.id] && mixedCoupon[item.id].length == 0 ? '暂无可用' : '请选择'
                  "
                  class="coupon-select"
                  @change="mixedCouponChange"
                  filterable
                >
                  <el-option
                    v-for="coupon in mixedCoupon[item.id]"
                    :key="coupon.coupon_id"
                    :label="coupon.label"
                    :value="coupon.coupon_id"
                  >
                    <span @click="selectCoupon(item.id, coupon.coupon_id)" style="display: block">
                      {{ coupon.label }}
                    </span>
                  </el-option>
                </el-select>
              </td>
            </template>
          </tr>
        </tbody>
      </table>
      <div v-if="discountId" class="discount-msg">
        <p class="title">{{ shop.discount && shop.discount.title }}</p>
        <p class="msg" v-if="shop.discount">
          <span v-for="(item, index) in shop.discount.rules" :key="index">
            <template v-if="index > 0">，</template>
            <template v-if="item.type == 1">
              当前满{{ item.condition }}门课程优惠
              <span>{{ (item.price / 100).toFixed(2) }}</span>
            </template>
            <template v-else-if="item.type == 2">
              满{{ (item.condition / 100).toFixed(2) }}优惠
              <span>{{ (item.price / 100).toFixed(2) }}</span>
            </template>
            <template v-else-if="item.type == 3">
              当前满{{ item.condition }}门课程打{{ item.rebate / 10 }}折
            </template>
          </span>
        </p>
      </div>
    </div>
    <div class="balance-detail">
      <div class="order-title">结算信息</div>
      <div class="item-wrap">
        <div v-if="!discountId && !packageId" class="item">
          <div class="empty"></div>
          <div class="content">
            <div class="label">合计：</div>
            <span class="rmb price-wrap">
              <Currency class="currency-mini"></Currency>
              <span>
                {{ shop.price | price }}
              </span>
            </span>
          </div>
        </div>
        <div v-if="type == 21 && $store.getters.showVip" class="item">
          <div class="empty"></div>
          <div class="content">
            <div class="label">会员优惠：</div>
            <span class="rmb price-wrap">
              <Currency class="currency-mini"></Currency>
              <span>
                {{ shop.vip_discount | price }}
              </span>
            </span>
          </div>
        </div>
        <div v-if="type == 12" class="item">
          <div class="empty"></div>
          <div class="content">
            <div class="label">运费：</div>
            <span class="rmb price-wrap" :class="{ 'coupon-none': couponList.length == 0 }">
              <Currency></Currency>
              <span>{{ shop.ship_price | price }}</span>
            </span>
          </div>
        </div>
        <div
          class="item coupon"
          v-if="
            type != 17 &&
            !discountId &&
            !packageId &&
            this.$store.state.commonSetting.switch_coupon_module === 1
          "
        >
          <div class="empty"></div>
          <!--          会员和套卷目前不支持优惠券-->
          <div class="content" v-if="type != 20 && type != 21">
            <div class="label">优惠券：</div>
            <el-select
              v-model="couponId"
              :placeholder="couponList.length == 0 ? '暂无可用' : '请选择'"
              class="coupon-select"
              @change="couponChange"
              filterable
              style="width: 178px"
            >
              <el-option
                v-for="item in couponList"
                :key="item.coupon_id"
                :label="item.label"
                :value="item.coupon_id"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div v-if="!discountId && !packageId" class="item price">
          <div class="empty"></div>
          <div class="content">
            <div class="label bold5">应付金额：</div>
            <span class="rmb price-wrap">
              <Currency class="currency-mini"></Currency>
              <span>{{ pay_price | price }}</span>
            </span>
          </div>
        </div>
        <template v-if="discountId || packageId">
          <div class="item">
            <div class="empty"></div>
            <div class="content">
              <div class="label">合计：</div>
              <span class="rmb price-wrap">
                <Currency class="currency-mini"></Currency>
                <span>
                  {{ shop.price | price }}
                </span>
              </span>
            </div>
          </div>
          <div v-if="discountId" class="item">
            <div class="empty"></div>
            <div class="content">
              <div class="label">联报优惠：</div>
              <span class="rmb price-wrap">
                <Currency class="currency-mini"></Currency>
                <span>
                  {{ shop.discount_price | price }}
                </span>
              </span>
            </div>
          </div>
          <div class="item">
            <div class="empty"></div>
            <div class="content">
              <div class="label">优惠券：</div>
              <span class="rmb price-wrap">
                <Currency class="currency-mini"></Currency>
                <span>
                  {{ shop.coupon_price | price }}
                </span>
              </span>
            </div>
          </div>
          <div class="item price">
            <div class="empty"></div>
            <div class="content">
              <div class="label bold5">应付金额：</div>
              <span class="rmb price-wrap">
                <Currency class="currency-mini"></Currency>
                <span>{{ shop.order_price | price }}</span>
              </span>
            </div>
          </div>
        </template>
      </div>
      <div class="submit-wrap">
        <div class="submit" @click="submitOrder">提交订单</div>
      </div>
    </div>
    <AddressForm
      ref="form"
      :tip="shop.is_materials == 1 && type != 12 ? '此地址只用于邮寄实体教材，请准确填写' : ''"
      @success="getAddress"
    ></AddressForm>
  </div>
</template>
<script>
import AddressForm from '../../components/AddressForm.vue';
import OrderStep from './components/OrderStep.vue';

export default {
  name: 'OrderConfirm',
  components: {
    OrderStep,
    AddressForm,
  },
  data() {
    return {
      id: this.$route.params.id,
      type: this.$route.query.type,
      dateLength: this.$route.query.dateLength, //会员开通时长
      num: this.$route.query.num || 1,
      type_open_number: this.$route.query.type_open_number,
      discountId: this.$route.query.discount_id,
      packageId: this.$route.query.package_id,
      shop: {},
      couponList: [],
      coupon: {},
      couponId: 0,
      addressExpand: 0,
      addressList: [],
      address_id: '',
      mixedCoupon: {},
    };
  },
  computed: {
    pay_price() {
      return this.shop.order_price;
    },
    switch_coupon_module() {
      return this.$store.state.commonSetting.switch_coupon_module;
    },
  },
  watch: {
    switch_coupon_module() {
      if (!this.discountId) {
        this.getCoupon();
      }
    },
  },
  async created() {
    let data = await this.getShopInfo();
    if (data.code == '203') {
      this.$message.warning(data.msg);
      this.$router.go(-1);
      return;
    }
    this.shop = data.info;
    if (this.type != 20 && this.type != 21) {
      //type = 20为会员，会员没有优惠券
      // 单个商品下单数据处理
      if (!this.discountId && !this.packageId) {
        this.getCoupon();
      } else {
        // 获取优惠券
        let arr = [];
        for (let value of data.info.items) {
          let obj = {};
          obj.shop_id = value.id;
          obj.type = value.shop_type;
          obj.price = (value.price - value.discount_price) / 100;
          arr.push(obj);
          value.checked_coupon_id = '';
        }
        this.getMixedCoupon(JSON.stringify(arr));
      }
    }
    if (this.type == 12 || this.shop.is_materials == 1) {
      await this.getAddress();
    }
  },
  methods: {
    async getShopInfo() {
      let params = {
        order_type: this.$route.query.order_type || 1,
      };
      // 判断是否联报订单
      if (this.discountId) {
        params.discount_id = this.discountId;
        params.shop_infos = this.$route.query.shop_infos;
      } else if (this.packageId) {
        params.package_id = this.packageId;
        params.shop_infos = this.$route.query.shop_infos;
      } else {
        params.shop_infos = JSON.stringify([
          {
            shop_id: this.id,
            shop_type: this.type,
            product_number: this.num,
            type: this.dateLength,
            type_open_number: this.type_open_number,
          },
        ]);
      }
      if (this.type == 12) {
        params.product_number = this.num;
      }
      let data = await this.$http.post('/api/app/order/shopInfo', params);
      return data;
    },
    async getCoupon() {
      if (
        this.type == 17 ||
        this.packageId ||
        this.$store.state.commonSetting.switch_coupon_module != 1
      ) {
        return;
      }
      this.couponList = await this.$http.post('/api/app/userCouponWithGoods', {
        shop_id: this.id,
        type: this.type,
        product_number: this.num,
      });
      this.couponList.forEach((c) => {
        c.label = '满' + c.full_reduction / 100 + '减' + c.discounted_price / 100;
      });
      if (this.couponList.length > 0) {
        this.couponList.unshift({
          id: 0,
          label: '不使用优惠券',
          discounted_price: 0,
        });
      } else {
        this.couponId = '';
      }
      if (this.couponList.length == 1) {
        this.coupon = this.couponList[0];
        this.couponId = this.coupon.coupon_id;
      } else if (this.couponList.length > 1) {
        let coupon = this.couponList.filter(
          (c) => c.coupon_id == this.shop.items[0].checked_coupon.coupon_id,
        )[0];
        if (coupon) {
          this.coupon = coupon;
          this.couponId = coupon.coupon_id;
        }
      }
    },
    async getMixedCoupon(arr) {
      this.mixedCoupon = await this.$http.post('/api/app/userCouponMixedGoods', {
        shop_infos: arr,
      });
      for (let i in this.mixedCoupon) {
        let arr = this.mixedCoupon[i];
        for (let value of arr) {
          value.label = '满' + value.full_reduction / 100 + '减' + value.discounted_price / 100;
        }
        if (arr.length > 0) {
          arr.unshift({
            id: 0,
            label: '不使用优惠券',
            discounted_price: 0,
          });
        }
      }
    },
    async submitOrder() {
      let params = {};
      // 判断是否联报订单
      let shop_infos = [];
      if (this.discountId || this.packageId) {
        let arr = this.shop.items;
        for (let value of arr) {
          let obj = {};
          obj.shop_id = value.id;
          obj.coupon_id = value.checked_coupon_id || '';
          obj.shop_type = value.shop_type;
          shop_infos.push(obj);
        }
        params.order_type = this.$route.query.order_type;
        if (this.discountId) {
          params.discount_id = this.discountId;
        } else {
          params.package_id = this.packageId;
        }
        params.shop_infos = JSON.stringify(shop_infos);
      } else {
        params.order_type = 1;
        shop_infos.push({
          shop_id: this.id,
          shop_type: this.type,
          product_number: this.num,
          type: this.dateLength,
          type_open_number: this.type_open_number,
          coupon_id: this.couponId || 0,
        });

        params.shop_infos = JSON.stringify(shop_infos);
      }

      if (this.type == 12 || this.shop.is_materials == 1) {
        if (!this.address_id) {
          this.$info('请选择收货地址');
          return;
        }
        params.address_id = this.address_id;
      }
      let data = await this.$http.post('/api/app/order/downOrder', params);
      if (data.code == 203) {
        data = JSON.parse(data.msg);
        await this.$warning(data.msg);
        this.$router.push({
          name: 'OrderPay',
          params: {
            id: data.data.order_id,
          },
          query: {
            type: this.type,
            shop_id: this.id,
          },
        });
      } else if (data.pay_status == 2) {
        this.$router.push({
          name: 'OrderSuccess',
          params: {
            id: data.id,
          },
          query: {
            shop_id: this.id,
            type: this.$route.query.type,
          },
        });
      } else {
        this.$router.push({
          name: 'OrderPay',
          params: {
            id: data.id,
          },
          query: {
            shop_id: this.id,
            type: this.$route.query.type,
          },
        });
      }
    },
    async couponChange() {
      let data = await this.$http.post('/api/app/order/selectCoupon', {
        shop_id: this.id,
        coupon_id: this.couponId,
        product_number: this.num,
        shop_type: this.type,
      });
      this.shop.order_price = data.order_price;
      this.coupon = this.couponList.filter((c) => c.coupon_id == this.couponId)[0];
    },
    async mixedCouponChange() {
      let arr = this.shop.items;
      let shop_infos = [];
      for (let value of arr) {
        let obj = {};
        obj.shop_id = value.id;
        obj.coupon_id = value.checked_coupon_id || '';
        shop_infos.push(obj);
      }
      let data = await this.$http.post('/api/app/order/shopInfo', {
        order_type: this.$route.query.order_type || 1,
        discount_id: this.discountId,
        package_id: this.packageId,
        shop_infos: JSON.stringify(shop_infos),
      });
      for (let value of data.info.items) {
        value.checked_coupon_id =
          value.checked_coupon && value.checked_coupon.coupon_id
            ? value.checked_coupon.coupon_id
            : '';
      }
      this.shop = data.info;
    },
    selectCoupon(id, c_id) {
      for (let value of this.shop.items) {
        if (value.id != id && value.checked_coupon_id == c_id) {
          value.checked_coupon_id = '';
        }
      }
    },
    async getAddress() {
      this.addressList = await this.$http.get('/api/app/address');
      let address = this.addressList.filter((a) => a.is_default == 1)[0];
      if (address) {
        this.address_id = address.id;
      }
    },
    addAddress() {
      this.$refs.form.showForm();
    },
  },
};
</script>
<style lang="scss" scoped>
@import '../../css/order-confirm.scss';
</style>
